import axios from 'axios';
import { captureException, slowRequest, authorization, unauthorized, applyIdentity, relationships } from '/app/services/middlewares';

const config = {
    timeout: 70000,
};

export default requester => {
    return {
        /**
         * Rate mentoring
         *
         * @param  {string} mentoringId
         * @param  {object} payload
         * @return {object}
         */
        rateMentoring(mentoringId, payload) {
            return requester.post(`/game/mentoring/${mentoringId}/rates`, payload);
        },

        /**
         * Retrives award ideas.
         *
         * @param {string} handle
         */
        awardIdeas (handle, params) {
            return requester.get(`/award/ideas/${handle}`, { params });
        },

        /**
         * Retrives award medals.
         *
         * @param {string} handle
         */
        awardMedals (handle, params) {
            return requester.get(`/award/medals/${handle}`, { params });
        },

        /**
         * Retrives award medals meta.
         *
         * @param {string} handle
         */
        awardMedalsMeta (handle, params) {
            return requester.get(`/award/medals/${handle}/meta`, { params });
        },

        /**
         * Retrives user highlights
         * 
         * @param {string} handle
         */
        highlights (params) {
            const requester = axios.create(config);

            captureException(requester);
            slowRequest(requester);
            authorization(requester);
            unauthorized(requester);
            applyIdentity(requester);
            relationships(requester, {
                fields: []
            });

            // Cross-service aggregation: routinely slower than the 3s default
            // budget. Raise the bar instead of ignoring it, so a real
            // regression on this endpoint still reaches Sentry.
            return requester.get('https://apps.bignervelab.com/v1/gamedash/highlights', {
                params,
                slowRequest: { warn: 8000, critical: 15000 },
            })
        },

        /**
         * Idea rating flow - one-tap Mentoring choices
         */
        mentoringChoices () {
            return requester.get('/mentoring/feedback-choices');
        },
    };
}
